const config = {
	api: "https://lkj99.kr",
};

export { config };
